import { useCallback } from 'react';
import AnimatedGlyphs from "./private/AnimatedGlyphs.js";
import BaseGlyphSeries from "./private/BaseGlyphSeries.js";
import defaultRenderGlyph from "./private/defaultRenderGlyph.js";
import { jsx as _jsx } from "react/jsx-runtime";
export default function AnimatedGlyphSeries(_ref) {
  let {
    renderGlyph = defaultRenderGlyph,
    ...props
  } = _ref;
  const renderGlyphs = useCallback(glyphsProps => /*#__PURE__*/_jsx(AnimatedGlyphs, {
    ...glyphsProps,
    renderGlyph: renderGlyph
  }), [renderGlyph]);
  return /*#__PURE__*/_jsx(BaseGlyphSeries, {
    ...props,
    renderGlyphs: renderGlyphs
  });
}